import { Injectable } from '@angular/core';
import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-angular';

@Injectable({
  providedIn: 'root'
})
export class AmplifyTranslationsService {

  private readonly amplifyTranslations = {
    pl_PL: {
      'Account recovery requires verified contact information':
        'Odzyskiwanie konta wymaga zweryfikowanych danych kontaktowych',
      'Add your Profile': 'Dodaj swój profil',
      'Add your Website': 'Dodaj swoją stronę internetową',
      'Back to Sign In': 'Powrót do logowania',
      'Change Password': 'Zmień hasło',
      Changing: 'Zmienianie',
      Code: 'Kod',
      'Confirm Password': 'Potwierdź hasło',
      'Confirm Sign Up': 'Potwierdź rejestrację',
      'Confirm SMS Code': 'Potwierdź kod SMS',
      'Confirm TOTP Code': 'Potwierdź kod TOTP',
      Confirm: 'Potwierdź',
      'Confirmation Code': 'Kod potwierdzający',
      Confirming: 'Potwierdzanie',
      'Create a new account': 'Utwórz nowe konto',
      'Create Account': 'Utwórz konto',
      'Creating Account': 'Tworzenie konta',
      'Dismiss alert': 'Zamknij ostrzeżenie',
      Email: 'Adres e-mail',
      'Enter your Birthdate': 'Wprowadź swoją datę urodzenia',
      'Enter your code': 'Wprowadź swój kod',
      'Enter your Confirmation Code': 'Wprowadź swój kod potwierdzający',
      'Enter your Email': 'Wprowadź swój adres e-mail',
      'Enter your Family Name': 'Wprowadź swoje nazwisko rodowe',
      'Enter your Given Name': 'Wprowadź swoje imię',
      'Enter your Middle Name': 'Wprowadź swoje drugie imię',
      'Enter your Name': 'Wprowadź swoje nazwisko',
      'Enter your Nickname': 'Wprowadź swoją nazwę',
      'Enter your Password': 'Wprowadź swoje hasło',
      'Enter your phone number': 'Wprowadź swój numer telefonu',
      'Enter your Preferred Username': 'Wprowadź preferowaną nazwę użytkownika',
      'Enter your username': 'Wprowadź swój adres e-mail',
      'Enter your Username': 'Wprowadź swój adres e-mail',
      'Enter username': 'Wprowadź adres e-mail',
      'Enter your email': 'Wprowadź swój adres e-mail',
      'Forgot password?': 'Zapomniałeś hasła?',
      'Forgot your password?': 'Zapomniałeś swojego hasła?',
      'Hide password': 'Ukryj hasło',
      'It may take a minute to arrive': 'To może potrwać chwilę',
      Loading: 'Ładowanie',
      'New password': 'Nowe hasło',
      or: 'lub',
      Password: 'Hasło',
      'Phone Number': 'Numer telefonu',
      'Please confirm your Password': 'Proszę potwierdź swoje hasło',
      'Resend Code': 'Wyślij kod ponownie',
      'Reset your password': 'Zresetuj swoje hasło',
      'Reset your Password': 'Zresetuj swoje hasło',
      'Send code': 'Wyślij kod',
      'Send Code': 'Wyślij Kod',
      Sending: 'Wysyłanie',
      'Setup TOTP': 'Konfiguracja TOTP',
      'Show password': 'Pokaż hasło',
      'Sign in to your account': 'Zaloguj się do swojego konta',
      'Sign In with Amazon': 'Zaloguj się przez Amazon',
      'Sign In with Apple': 'Zaloguj się przez Apple',
      'Sign In with Facebook': 'Zaloguj się przez Facebooka',
      'Sign In with Google': 'Zaloguj się przez Google',
      'Sign in': 'Zaloguj się',
      'Sign In': 'Zaloguj się',
      'Signing in': 'Logowanie',
      Skip: 'Pomiń',
      Submit: 'Zatwierdź',
      Submitting: 'Przesyłanie',
      Username: 'Nazwa użytkownika',
      'Verify Contact': 'Zweryfikuj dane kontaktowe',
      Verify: 'Zweryfikuj',
      'We Emailed You': 'Wysłaliśmy Ci wiadomość e-mail',
      'We Sent A Code': 'Wysłaliśmy Ci kod',
      'We Texted You': 'Wysłaliśmy Ci wiadomość',
      'Your code is on the way. To log in, enter the code we emailed to':
        'Wysłaliśmy Ci kod. Aby się zalogować, wprowadź kod, który otrzymałeś na powiązany adres e-mail',
      'Your code is on the way. To log in, enter the code we sent you':
        'Wysłaliśmy Ci kod. Aby się zalogować, wprowadź otrzymany kod',
      'Your code is on the way. To log in, enter the code we texted to':
        'Wysłaliśmy Ci kod. Aby się zalogować, wprowadź kod, który otrzymałeś w wiadomości',
      'Incorrect username or password': 'Błędne hasło lub adres e-mail',
      'Invalid password format':
        'Nieprawidłowy format hasła (hasło powinno zawierać: dużą literę, małą literę, cyfrę, znak specjalny)',
      'Invalid phone number format': 'Nieprawidłowy format numeru telefonu',
      'Lost your code? ': 'Czy utraciłeś kod weryfikacyjny? ',
      'Network error': 'Błąd sieci',
      'New Password': 'Nowe hasło',
      'No account? ': 'Czy nie masz konta?',
      'User already exists': 'Użytkownik już istnieje',
      'User does not exist': 'Użytkownik nie istnieje',
      'Username cannot be empty': 'Wprowadź adres e-mail',
      'Username/client id combination not found.': 'Nie znaleziono konta',
      'An account with the given email already exists.':
        'Istnieje już konto powiązane z podanym adresem e-mail',
      'Confirm a Code': 'Potwierdź kod',
      'Confirm Sign In': 'Potwierdź logowanie',
      'Create account': 'Utwórz konto',
      'Password must contain at least one lowercase letter':
        'Hasło powinno zawierać co najmniej jedną małą literę',
      'Password attempts exceeded': 'Przekroczono maksymalną ilość prób logowania',
      'Incorrect username or password.': 'Nieprawidłowy adres e-mail lub hasło',
    },
    en_US: {
      'Account recovery requires verified contact information':
        'Account recovery requires verified contact information',
      'Add your Profile': 'Add your Profile',
      'Add your Website': 'Add your Website',
      'Back to Sign In': 'Back to Sign In',
      'Change Password': 'Change Password',
      Changing: 'Changing',
      Code: 'Code',
      'Confirm Password': 'Confirm Password',
      'Confirm Sign Up': 'Confirm Sign Up',
      'Confirm SMS Code': 'Confirm SMS Code',
      'Confirm TOTP Code': 'Confirm TOTP Code',
      Confirm: 'Confirm',
      'Confirmation Code': 'Confirmation Code',
      Confirming: 'Confirming',
      'Create a new account': 'Create a new account',
      'Create Account': 'Create Account',
      'Creating Account': 'Creating Account',
      'Dismiss alert': 'Dismiss alert',
      Email: 'Email',
      'Enter your Birthdate': 'Enter your Birthdate',
      'Enter your code': 'Enter your code',
      'Enter your Confirmation Code': 'Enter your Confirmation Code',
      'Enter your Email': 'Enter your Email',
      'Enter your Family Name': 'Enter your Family Name',
      'Enter your Given Name': 'Enter your Given Name',
      'Enter your Middle Name': 'Enter your Middle Name',
      'Enter your Name': 'Enter your Name',
      'Enter your Nickname': 'Enter your Nickname',
      'Enter your Password': 'Enter your Password',
      'Enter your phone number': 'Enter your phone number',
      'Enter your Preferred Username': 'Enter your Preferred Username',
      'Enter your username': 'Enter your email',
      'Enter your Username': 'Enter your email',
      'Enter username': 'Enter your email',
      'Enter your email': 'Enter your email',
      'Forgot password?': 'Forgot password?',
      'Forgot your password?': 'Forgot your password?',
      'Hide password': 'Hide password',
      'It may take a minute to arrive': 'It may take a minute to arrive',
      Loading: 'Loading',
      'New password': 'New password',
      or: 'or',
      Password: 'Password',
      'Phone Number': 'Phone Number',
      'Please confirm your Password': 'Please confirm your Password',
      'Resend Code': 'Resend Code',
      'Reset your password': 'Reset your password',
      'Reset your Password': 'Reset your Password',
      'Send code': 'Send code',
      'Send Code': 'Send Code',
      Sending: 'Sending',
      'Setup TOTP': 'Setup TOTP',
      'Show password': 'Show password',
      'Sign in to your account': 'Sign in to your account',
      'Sign In with Amazon': 'Sign In with Amazon',
      'Sign In with Apple': 'Sign In with Apple',
      'Sign In with Facebook': 'Sign In with Facebook',
      'Sign In with Google': 'Sign In with Google',
      'Sign in': 'Sign in',
      'Sign In': 'Sign In',
      'Signing in': 'Signing in',
      Skip: 'Skip',
      Submit: 'Submit',
      Submitting: 'Submitting',
      Username: 'Username',
      'Verify Contact': 'Verify Contact',
      Verify: 'Verify',
      'We Emailed You': 'We Emailed You',
      'We Sent A Code': 'We Sent A Code',
      'We Texted You': 'We Texted You',
      'Your code is on the way. To log in, enter the code we emailed to':
        'Your code is on the way. To log in, enter the code we emailed to',
      'Your code is on the way. To log in, enter the code we sent you':
        'Your code is on the way. To log in, enter the code we sent you',
      'Your code is on the way. To log in, enter the code we texted to':
        'Your code is on the way. To log in, enter the code we texted to',
      'Incorrect username or password': 'Incorrect username or password',
      'Invalid password format':
        'Invalid password format (password should contain: uppercase letter, lowercase letter, number, special character)',
      'Invalid phone number format': 'Invalid phone number format',
      'Lost your code? ': 'Lost your code? ',
      'Network error': 'Network error',
      'New Password': 'New Password',
      'No account? ': 'No account? ',
      'User already exists': 'User already exists',
      'User does not exist': 'User does not exist',
      'Username cannot be empty': 'Username cannot be empty',
      'Username/client id combination not found.': 'Username/client id combination not found.',
      'An account with the given email already exists.':
        'An account with the given email already exists.',
      'Confirm a Code': 'Confirm a Code',
      'Confirm Sign In': 'Confirm Sign In',
      'Create account': 'Create account',
      'Password must contain at least one lowercase letter':
        'Password must contain at least one lowercase letter',
      'Password attempts exceeded': 'Password attempts exceeded',
      'Incorrect username or password.': 'Incorrect username or password.',
    },
    pseudo_PL: {
      'Account recovery requires verified contact information':
        'A$c$c$o$u$n$t$ $r$e$c$o$v$e$r$y$ $r$e$q$u$i$r$e$s$ $v$e$r$i$f$i$e$d$ $c$o$n$t$a$c$t$ $i$n$f$o$r$m$a$t$i$o$n',
      'Add your Profile': 'A$d$d$ $y$o$u$r$ $P$r$o$f$i$l$e',
      'Add your Website': 'A$d$d$ $y$o$u$r$ $W$e$b$s$i$t$e',
      'Back to Sign In': 'B$a$c$k$ $t$o$ $S$i$g$n$ $I$n',
      'Change Password': 'C$h$a$n$g$e$ $P$a$s$s$w$o$r$d',
      Changing: 'C$h$a$n$g$i$n$g',
      Code: 'C$o$d$e',
      'Confirm Password': 'C$o$n$f$i$r$m$ $P$a$s$s$w$o$r$d',
      'Confirm Sign Up': 'C$o$n$f$i$r$m$ $S$i$g$n$ $U$p',
      'Confirm SMS Code': 'C$o$n$f$i$r$m$ $S$M$S$ $C$o$d$e',
      'Confirm TOTP Code': 'C$o$n$f$i$r$m$ $T$O$T$P$ $C$o$d$e',
      Confirm: 'C$o$n$f$i$r$m',
      'Confirmation Code': 'C$o$n$f$i$r$m$a$t$i$o$n$ $C$o$d$e',
      Confirming: 'C$o$n$f$i$r$m$i$n$g',
      'Create a new account': 'C$r$e$a$t$e$ $a$ $n$e$w$ $a$c$c$o$u$n$t',
      'Create Account': 'C$r$e$a$t$e$ $A$c$c$o$u$n$t',
      'Creating Account': 'C$r$e$a$t$i$n$g$ $A$c$c$o$u$n$t',
      'Dismiss alert': 'D$i$s$m$i$s$s$ $a$l$e$r$t',
      Email: 'E$m$a$i$l',
      'Enter your Birthdate': 'E$n$t$e$r$ $y$o$u$r$ $B$i$r$t$h$d$a$t$e',
      'Enter your code': 'E$n$t$e$r$ $y$o$u$r$ $c$o$d$e',
      'Enter your Confirmation Code': 'E$n$t$e$r$ $y$o$u$r$ $C$o$n$f$i$r$m$a$t$i$o$n$ $C$o$d$e',
      'Enter your Email': 'E$n$t$e$r$ $y$o$u$r$ $E$m$a$i$l',
      'Enter your Family Name': 'E$n$t$e$r$ $y$o$u$r$ $F$a$m$i$l$y$ $N$a$m$e',
      'Enter your Given Name': 'E$n$t$e$r$ $y$o$u$r$ $G$i$v$e$n$ $N$a$m$e',
      'Enter your Middle Name': 'E$n$t$e$r$ $y$o$u$r$ $M$i$d$d$l$e$ $N$a$m$e',
      'Enter your Name': 'E$n$t$e$r$ $y$o$u$r$ $N$a$m$e',
      'Enter your Nickname': 'E$n$t$e$r$ $y$o$u$r$ $N$i$c$k$n$a$m$e',
      'Enter your Password': 'E$n$t$e$r$ $y$o$u$r$ $P$a$s$s$w$o$r$d',
      'Enter your phone number': 'E$n$t$e$r$ $y$o$u$r$ $p$h$o$n$e$ $n$u$m$b$e$r',
      'Enter your Preferred Username': 'E$n$t$e$r$ $y$o$u$r$ $P$r$e$f$e$r$r$e$d$ $U$s$e$r$n$a$m$e',
      'Enter your username': 'E$n$t$e$r$ $y$o$u$r$ $e$m$a$i$l',
      'Enter your Username': 'E$n$t$e$r$ $y$o$u$r$ $e$m$a$i$l',
      'Enter username': 'E$n$t$e$r$ $y$o$u$r$ $e$m$a$i$l',
      'Enter your email': 'E$n$t$e$r$ $y$o$u$r$ $e$m$a$i$l',
      'Forgot password?': 'F$o$r$g$o$t$ $p$a$s$s$w$o$r$d$?',
      'Forgot your password?': 'F$o$r$g$o$t$ $y$o$u$r$ $p$a$s$s$w$o$r$d$?',
      'Hide password': 'H$i$d$e$ $p$a$s$s$w$o$r$d',
      'It may take a minute to arrive': 'I$t$ $m$a$y$ $t$a$k$e$ $a$ $m$i$n$u$t$e$ $t$o$ $a$r$r$i$v$e',
      Loading: 'L$o$a$d$i$n$g',
      'New password': 'N$e$w$ $p$a$s$s$w$o$r$d',
      or: 'o$r',
      Password: 'P$a$s$s$w$o$r$d',
      'Phone Number': 'P$h$o$n$e$ $N$u$m$b$e$r',
      'Please confirm your Password': 'P$l$e$a$s$e$ $c$o$n$f$i$r$m$ $y$o$u$r$ $P$a$s$s$w$o$r$d',
      'Resend Code': 'R$e$s$e$n$d$ $C$o$d$e',
      'Reset your password': 'R$e$s$e$t$ $y$o$u$r$ $p$a$s$s$w$o$r$d',
      'Reset your Password': 'R$e$s$e$t$ $y$o$u$r$ $P$a$s$s$w$o$r$d',
      'Send code': 'S$e$n$d$ $c$o$d$e',
      'Send Code': 'S$e$n$d$ $C$o$d$e',
      Sending: 'S$e$n$d$i$n$g',
      'Setup TOTP': 'S$e$t$u$p$ $T$O$T$P',
      'Show password': 'S$h$o$w$ $p$a$s$s$w$o$r$d',
      'Sign in to your account': 'S$i$g$n$ $i$n$ $t$o$ $y$o$u$r$ $a$c$c$o$u$n$t',
      'Sign In with Amazon': 'S$i$g$n$ $I$n$ $w$i$t$h$ $A$m$a$z$o$n',
      'Sign In with Apple': 'S$i$g$n$ $I$n$ $w$i$t$h$ $A$p$p$l$e',
      'Sign In with Facebook': 'S$i$g$n$ $I$n$ $w$i$t$h$ $F$a$c$e$b$o$o$k',
      'Sign In with Google': 'S$i$g$n$ $I$n$ $w$i$t$h$ $G$o$o$g$l$e',
      'Sign in': 'S$i$g$n$ $i$n',
      'Sign In': 'S$i$g$n$ $I$n',
      'Signing in': 'S$i$g$n$i$n$g$ $i$n',
      Skip: 'S$k$i$p',
      Submit: 'S$u$b$m$i$t',
      Submitting: 'S$u$b$m$i$t$t$i$n$g',
      Username: 'U$s$e$r$n$a$m$e',
      'Verify Contact': 'V$e$r$i$f$y$ $C$o$n$t$a$c$t',
      Verify: 'V$e$r$i$f$y',
      'We Emailed You': 'W$e$ $E$m$a$i$l$e$d$ $Y$o$u',
      'We Sent A Code': 'W$e$ $S$e$n$t$ $A$ $C$o$d$e',
      'We Texted You': 'W$e$ $T$e$x$t$e$d$ $Y$o$u',
      'Your code is on the way. To log in, enter the code we emailed to':
        'Y$o$u$r$ $c$o$d$e$ $i$s$ $o$n$ $t$h$e$ $w$a$y$.$ $T$o$ $l$o$g$ $i$n$,$ $e$n$t$e$r$ $t$h$e$ $c$o$d$e$ $w$e$ $e$m$a$i$l$e$d$ $t$o',
      'Your code is on the way. To log in, enter the code we sent you':
        'Y$o$u$r$ $c$o$d$e$ $i$s$ $o$n$ $t$h$e$ $w$a$y$.$ $T$o$ $l$o$g$ $i$n$,$ $e$n$t$e$r$ $t$h$e$ $c$o$d$e$ $w$e$ $s$e$n$t$ $y$o$u',
      'Your code is on the way. To log in, enter the code we texted to':
        'Y$o$u$r$ $c$o$d$e$ $i$s$ $o$n$ $t$h$e$ $w$a$y$.$ $T$o$ $l$o$g$ $i$n$,$ $e$n$t$e$r$ $t$h$e$ $c$o$d$e$ $w$e$ $t$e$x$t$e$d$ $t$o',
      'Incorrect username or password': 'I$n$c$o$r$r$e$c$t$ $u$s$e$r$n$a$m$e$ $o$r$ $p$a$s$s$w$o$r$d',
      'Invalid password format':
        'I$n$v$a$l$i$d$ $p$a$s$s$w$o$r$d$ $f$o$r$m$a$t$ $($p$a$s$s$w$o$r$d$ $s$h$o$u$l$d$ $c$o$n$t$a$i$n$:$ $u$p$p$e$r$c$a$s$e$ $l$e$t$t$e$r$,$ $l$o$w$e$r$c$a$s$e$ $l$e$t$t$e$r$,$ $n$u$m$b$e$r$,$ $s$p$e$c$i$a$l$ $c$h$a$r$a$c$t$e$r$)',
      'Invalid phone number format': 'I$n$v$a$l$i$d$ $p$h$o$n$e$ $n$u$m$b$e$r$ $f$o$r$m$a$t',
      'Lost your code? ': 'L$o$s$t$ $y$o$u$r$ $c$o$d$e$? ',
      'Network error': 'N$e$t$w$o$r$k$ $e$r$r$o$r',
      'New Password': 'N$e$w$ $P$a$s$s$w$o$r$d',
      'No account? ': 'N$o$ $a$c$c$o$u$n$t$? ',
      'User already exists': 'U$s$e$r$ $a$l$r$e$a$d$y$ $e$x$i$s$t$s',
      'User does not exist': 'U$s$e$r$ $d$o$e$s$ $n$o$t$ $e$x$i$s$t',
      'Username cannot be empty': 'U$s$e$r$n$a$m$e$ $c$a$n$n$o$t$ $b$e$ $e$m$p$t$y',
      'Username/client id combination not found.': 'U$s$e$r$n$a$m$e$/c$l$i$e$n$t$ $i$d$ $c$o$m$b$i$n$a$t$i$o$n$ $n$o$t$ $f$o$u$n$d$.',
      'An account with the given email already exists.':
        'A$n$ $a$c$c$o$u$n$t$ $w$i$t$h$ $t$h$e$ $g$i$v$e$n$ $e$m$a$i$l$ $a$l$r$e$a$d$y$ $e$x$i$s$t$s$.',
      'Confirm a Code': 'C$o$n$f$i$r$m$ $a$ $C$o$d$e',
      'Confirm Sign In': 'C$o$n$f$i$r$m$ $S$i$g$n$ $I$n',
      'Create account': 'C$r$e$a$t$e$ $a$c$c$o$u$n$t',
      'Password must contain at least one lowercase letter':
        'P$a$s$s$w$o$r$d$ $m$u$s$t$ $c$o$n$t$a$i$n$ $a$t$ $l$e$a$s$t$ $o$n$e$ $l$o$w$e$r$c$a$s$e$ $l$e$t$t$e$r',
      'Password attempts exceeded': 'P$a$s$s$w$o$r$d$ $a$t$t$e$m$p$t$s$ $e$x$c$e$e$d$e$d',
      'Incorrect username or password.': 'I$n$c$o$r$r$e$c$t$ $u$s$e$r$n$a$m$e$ $o$r$ $p$a$s$s$w$o$r$d$.',
    }
  };

  constructor() {
    // Initialize with default translations
    try {
      I18n.putVocabularies(translations);
    } catch (error) {
      console.error('Error initializing Amplify translations:', error);
    }
  }

  /**
   * Set Amplify language based on app language
   * @param appLanguage - The app language code (e.g., 'pl_PL', 'en_US', 'pseudo_PL')
   */
  setAmplifyLanguage(appLanguage: string): void {
    try {
      // Map app language codes to Amplify language codes
      const amplifyLanguageMap: { [key: string]: string } = {
        'pl_PL': 'pl',
        'en_US': 'en',
        'pseudo_PL': 'pl' // Use Polish as base for pseudo-translation
      };

      const amplifyLanguage = amplifyLanguageMap[appLanguage] || 'pl';
      const translations = this.amplifyTranslations[appLanguage] || this.amplifyTranslations['pl_PL'];

      // Set the language and translations
      I18n.setLanguage(amplifyLanguage);
      I18n.putVocabulariesForLanguage(amplifyLanguage, translations);
    } catch (error) {
      console.error('Error setting Amplify language:', error);
    }
  }

  /**
   * Get current app language from localStorage
   * @returns The current app language code
   */
  getCurrentAppLanguage(): string {
    return localStorage.getItem('selectedLanguage') || 'pl_PL';
  }

  /**
   * Initialize Amplify translations with current app language
   */
  initializeWithCurrentLanguage(): void {
    const currentLanguage = this.getCurrentAppLanguage();
    this.setAmplifyLanguage(currentLanguage);
  }
}
